'use strict';

var GridFillDownButtonController = function GridFillDownButtonController($scope) {
  var gridPanel = $scope.gridPanelScope;
  $scope.fillDownCells = function () {
    gridPanel.fillDownCells();
  };
};
GridFillDownButtonController.$inject = ['$scope'];
module.exports = GridFillDownButtonController;